import { useEffect, useState } from 'preact/hooks';
import { changes } from '../../subs';
import { Change } from '../../types';

export function useVPAIDVolume(): number {
  const [volume, setVolume] = useState(0);

  useEffect(() => {
    function onChanges({ event, partial }: Change) {
      if (event === 'volume') setVolume(partial.volume!);
    }

    changes.subscribe(onChanges);
    return () => changes.unsubscribe(onChanges);
  }, []);

  return volume;
}
